module.exports = __webpack_public_path__ + "img/11.6f7be5d5.png";